import { useState, useEffect, useMemo } from 'react';
import { useLocation, useParams } from 'react-router-dom';
import { allRoutes, routeRegexMap } from '@/routes';
import useAuthStore from '@/store/Auth';

export default function useRouteValidation() {
  const { isPilot, isAdmin } = useAuthStore();
  const location = useLocation();
  const params = useParams();
  const [isExistingRoute, setIsExistingRoute] = useState(false);

  const routes = useMemo(
    () =>
      isPilot
        ? allRoutes.filter((route) => {
            if (route.name === 'integrations' && !isAdmin) return false;
            if (route.name === 'permissions' && !isAdmin) return false;
            return true;
          })
        : allRoutes.filter((route) => {
            if (route.name === 'permissions') return false;
            return true;
          }),
    [isPilot, isAdmin]
  );

  useEffect(() => {
    const exactMatch = routes.some((route) => location.pathname === route.link);

    const dynamicMatch = routes.some((route) => {
      const regex = routeRegexMap.get(route.link);
      return regex && regex.test(location.pathname);
    });

    setIsExistingRoute(exactMatch || dynamicMatch);
  }, [location, params, routes]);

  const isInsightsPage = useMemo(() => {
    const insightsRoutes = ['/', '/insights'];
    return (
      insightsRoutes.includes(location.pathname) ||
      location.pathname.startsWith('/insights/')
    );
  }, [location.pathname]);

  return { isExistingRoute, isInsightsPage };
}
